import React from "react";
import "./App.css";
import LocationMap from "./LocationMap";

import standardRoom from "./images/standard-room.jpeg";
import deluxeRoom from "./images/standard-room.jpeg";
import executiveRoom from "./images/standard-room.jpeg";
import suiteRoom from "./images/suite-room.jpeg";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";

import hero1 from "./images/hero1.jpeg";
import hero2 from "./images/hero2.jpeg";
import hero3 from "./images/hero3.jpeg";
import hero4 from "./images/hero4.jpeg";

function App() {
  return (
    <div>
      <header className="hero">

        <Swiper
          modules={[Autoplay, EffectFade]}
          effect="fade"
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          className="hero-slider"
        >

          <SwiperSlide>
            <img src={hero1} alt="Aaryan Comforts" />
          </SwiperSlide>

          <SwiperSlide>
            <img src={hero2} alt="Aaryan Comforts" />
          </SwiperSlide>

          <SwiperSlide>
            <img src={hero3} alt="Aaryan Comforts" />
          </SwiperSlide>

          <SwiperSlide>
            <img src={hero4} alt="Aaryan Comforts" />
          </SwiperSlide>

        </Swiper>

        <div className="hero-overlay"></div>

        <div className="hero-content">

          <h1>Aaryan Comforts</h1>

          <h3>A Unit of Ridhya Vistas</h3>

          <p>
            Premium Hotel • Jalahalli Cross • North Bangalore
          </p>

          <div className="hero-buttons">

            <a href="#rooms" className="btn">
              View Rooms
            </a>

            {/* 

            <a href="#contact" className="btn2">
              Book Now
            </a>
            */}

            <a
              href={`https://wa.me/917996555511?text=${encodeURIComponent(
                `Hi Aryan Comfort,

I would like to enquire about room availability.

📅 Check-in:
📅 Check-out:
👥 Number of Guests:

Please share the room availability and tariff.

Thank you!`
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn2"
            >
              Book Now
            </a>

          </div>

          <div className="scroll-down">
            ⌄
          </div>

        </div>

      </header>



      <nav className="navbar">
        <a href="#about">About</a>
        <a href="#rooms">Rooms</a>
        <a href="#facilities">Facilities</a>
        <a href="#contact">Contact</a>
      </nav>

      {/*
<section className="highlight-bar">
  <div>🏨 Premium Stay</div>
  <div>📶 Free WiFi</div>
  <div>🛡️ Secure Stay</div>
  <div>🍽️ Rooftop Dining</div>
  <div>🚇 Metro 350m</div>
  <div>💆 Spa & Salon</div>
</section>
*/}

      <section id="about" className="section">
        <h2>About Aaryan Comforts</h2>

        <p>
          <strong>Aaryan Comforts</strong>, a unit of <strong>Ridhya Vistas</strong>, is a comfortable hotel and lodge at
          <strong>Jalahalli Cross, North Bangalore</strong>, offering clean, spacious and affordable rooms for business travellers,
          families and corporate guests.
        </p>

        <p>
          Located just <strong>350 metres from Jalahalli Metro Station</strong>, we provide convenient access to
          <strong> Peenya Industrial Area, BIEC</strong>, major business parks, hospitals and educational institutions.
        </p>

        <p>
          Our facilities include <strong>AC rooms, free Wi-Fi, 24/7 reception, housekeeping, rooftop restaurant,
            salon &amp; spa and secure parking</strong>.
        </p>

        <p>
          Whether you’re visiting <strong>BIEC, Peenya, North Bangalore</strong> or simply looking for a comfortable stay
          near Jalahalli Metro, <strong>Aaryan Comforts</strong> offers convenience, comfort and warm hospitality.
        </p>
      </section>




      <section id="rooms" className="section">

        <h2>Our Premium Rooms</h2>

        <p className="room-subtitle">
          Experience comfort, elegance and warm hospitality at Aryan Comfort.
          Choose from our thoughtfully designed rooms for business, leisure and family stays.
        </p>

        <div className="room-grid">

          <div className="room-card">

            <img src={standardRoom} alt="Standard Room" />

            <div className="room-details">

              <h3>Standard Room</h3>

              <div className="price">
                From ₹1,999 / Night
              </div>

              <ul>
                <li>🛏 Queen Size Bed</li>
                <li>❄ Air Conditioned</li>
                <li>📶 Free Wi-Fi</li>
                <li>📺 Smart TV</li>
                <li>🚿 Attached Bathroom</li>
              </ul>

             <button
  className="book-btn"
  onClick={() =>
    window.open(
      `https://wa.me/917996555511?text=${encodeURIComponent(
        `Hi Aaryan Comforts,

I would like to enquire about the Executive Room.

📅 Check-in:
📅 Check-out:
👥 Number of Guests:

Please share the room availability and tariff.

Thank you!`
      )}`,
      "_blank"
    )
  }
>
  Book Now
</button>

            </div>

          </div>

          <div className="room-card">

            <img src={deluxeRoom} alt="Deluxe Room" />

            <div className="room-details">

              <h3>Deluxe Room</h3>

              <div className="price">
                From ₹2,499 / Night
              </div>

              <ul>
                <li>👑 King Size Bed</li>
                <li>❄ Air Conditioned</li>
                <li>📶 High Speed Wi-Fi</li>
                <li>📺 Smart TV</li>
                <li>☕ Tea/Coffee Maker</li>
              </ul>

              <button
  className="book-btn"
  onClick={() =>
    window.open(
      `https://wa.me/917996555511?text=${encodeURIComponent(
        `Hi Aaryan Comforts,

I would like to enquire about the Executive Room.

📅 Check-in:
📅 Check-out:
👥 Number of Guests:

Please share the room availability and tariff.

Thank you!`
      )}`,
      "_blank"
    )
  }
>
  Book Now
</button>

            </div>

          </div>

          <div className="room-card">

            <img src={executiveRoom} alt="Executive Room" />

            <div className="room-details">

              <h3>Executive Room</h3>

              <div className="price">
                From ₹2,999 / Night
              </div>

              <ul>
                <li>👔 Business Friendly</li>
                <li>💼 Work Desk</li>
                <li>📶 Premium Wi-Fi</li>
                <li>📺 Smart TV</li>
                <li>🧳 Spacious Interiors</li>
              </ul>

              <button
                className="book-btn"
                onClick={() =>
                  window.open(
                    `https://wa.me/917996555511?text=${encodeURIComponent(
                      `Hi Aaryan Comforts,

I would like to enquire about the Executive Room.

📅 Check-in:
📅 Check-out:
👥 Number of Guests:

Please share the room availability and tariff.

Thank you!`
                    )}`,
                    "_blank"
                  )
                }
              >
                Book Now
              </button>

            </div>

          </div>

          <div className="room-card">

            <img src={suiteRoom} alt="Suite Room" />

            <div className="room-details">

              <h3>Suite Room</h3>

              <div className="price">
                From ₹5,999 / Night
              </div>

              <ul>
                <li>✨ Luxury Suite</li>
                <li>🛋 Living Area</li>
                <li>👨‍👩‍👧‍👦 Family Friendly</li>
                <li>📺 Smart TV</li>
                <li>🛁 Premium Bathroom</li>
              </ul>

             <button
  className="book-btn"
  onClick={() =>
    window.open(
      `https://wa.me/917996555511?text=${encodeURIComponent(
        `Hi Aaryan Comforts,

I would like to enquire about the Executive Room.

📅 Check-in:
📅 Check-out:
👥 Number of Guests:

Please share the room availability and tariff.

Thank you!`
      )}`,
      "_blank"
    )
  }
>
  Book Now
</button>

            </div>

          </div>

        </div>

      </section>




      <section id="facilities" className="section">
        <h2>Facilities & Nearby Conveniences</h2>

        <div className="card-container">
          <div className="card">
            <h3>🏨 Facilities</h3>
            <p>✓ Secure CAR parking</p>
            <p>✓ Rooftop Restaurant</p>
            <p>✓ Salon & Spa</p>
            <p>✓ Free Wi-Fi</p>
            <p>✓ Air Conditioned Rooms</p>
            <p>✓ 24/7 Reception</p>
            <p>✓ Housekeeping</p>
            <p>✓ Safe & Secure Stay</p>
          </div>

          <div className="card">
            <h3>📍 Prime Location</h3>

            <p>✓ Metro Station – 350 meters</p>
            <p>✓ ATM Nearby</p>
            <p>✓ Shopping & Dining Nearby</p>
            <p>✓ Just 10 mins away from BIEC</p>
            <p>✓ Peenya Industrial Hub</p>
            <p>✓ Easy Access to City Attractions</p>
          </div>

          <div className="card">
            <h3>✨ Why Choose Us</h3>

            <p>✓ Top-Rated Hospitality with 4.3 Star rating</p>
            <p>✓ Premium Stays</p>
            <p>✓ Warm Hospitality</p>
            <p>✓ Modern Amenities</p>
            <p>✓ Comfortable Rooms</p>
            <p>✓ Memorable Experiences</p>
          </div>
        </div>
      </section>

      <section id="contact" className="contact-section">

        <h2>Contact Us</h2>

        <div className="contact-wrapper">

          <div className="contact-info">

            <div className="info-box">
              <h3>📍 Our Office Address</h3>
              <p>
                57/B, 1st Floor, SM Road,<br />
                Prashanth Nagar,<br />
                T. Dasarahalli, Jalahalli Cross<br />
                Bengaluru - 560057
              </p>
            </div>

            <div className="info-box">
              <h3>✉ General Enquiries</h3>
              <p>bookings@aaryancomforts.co.in</p>
            </div>

            <div className="info-box">
              <h3>☎ Call Us</h3>
              <p>+91 7996555511</p>
            </div>

            <div className="info-box">
              <h3>🕒 Our Timing</h3>
              <p>24 × 7 Reception</p>
            </div>

            <div className="info-box">
              <h3>🌐 Follow Us</h3>

              <div className="social-icons">

                <a
                  href="https://share.google/5b56qT3Wh5wWXAKZc"
                  target="_blank"
                  rel="noreferrer"
                >
                  📍 Google
                </a>

                <a
                  href="https://www.instagram.com/aaryan.comforts/"
                  target="_blank"
                  rel="noreferrer"
                >
                  📷 Instagram
                </a>

                <a
                  href="https://www.instagram.com/aaryan.comforts/"
                  target="_blank"
                  rel="noreferrer"
                >
                  👍 Facebook
                </a>

                <a
                  href={`https://wa.me/917996555511?text=${encodeURIComponent(
                    `Hi Aryan Comfort,

I would like to enquire about room availability.

📅 Check-in:
📅 Check-out:
👥 Number of Guests:

Please share the room availability and tariff.

Thank you!`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-btn whatsapp"
                >
                  💬 WhatsApp
                </a>

              </div>
            </div>

          </div>

          <form className="contact-form">

            <input
              type="text"
              placeholder="YOUR NAME"
            />

            <input
              type="email"
              placeholder="YOUR EMAIL"
            />

            <input
              type="tel"
              placeholder="YOUR CONTACT NO."
            />

            <textarea
              rows="6"
              placeholder="YOUR MESSAGE"
            ></textarea>

            <button type="submit">
              Submit
            </button>

          </form>

        </div>

      </section>

      <section className="section">
        <LocationMap />
      </section>

      <footer className="footer">
        <p>
          © 2026 Aryan Comfort | A Unit of Ridhya Vistas
        </p>
      </footer>
    </div>
  );
}

export default App;